<div class="bgColorWhite body-scroll">
  @if (showData) {
<div class="text-center boldText"><h3>{{ title }}</h3></div>
}

  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loading) {
<div style="margin-left: 30px; margin-right: 30px">
    <div class="actions-row">
      <button type="button" class="save-button" (click)="refreshData()">Refresh</button>
      <button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
    </div>
    <div class="col-md-12 boldText" style="width: 100%">
      <table class="table table-bordered table-striped table-condensed custom-table">
        <thead>
          <tr>
            <th>Tax Year</th>
          </tr>
        </thead>
        <tbody>
          @for (taxYear of taxYearSL; track $index) {
<tr [class.selected-row]="selectedTaxYear === taxYear.value">
            <td class="details-control" (click)="loadTaxYearDetails(taxYear.value)">
              @if (dataLoading[taxYear.value]) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}{{ taxYear.value }}
            </td>
          </tr>
}
        </tbody>
      </table>
    </div>

    @if (displayTable) {
<div class="col-md-12 boldText" style="width: 100%">
      <table class="table table-bordered table-striped table-condensed custom-table child-table">
        <thead>
          <tr>
            <th>Description</th>
            <th>Cite</th>
            <th class="rightAlign">Total Amount</th>
            @for (col of tableColumns; track $index) {
<th class="rightAlign">{{ col }}</th>
}
          </tr>
        </thead>
        <tbody>
          @for (row of tableRows; track $index) {
<tr>
            <td>{{ row['Description'] }}</td>
            <td>{{ row['Cite'] }}</td>
            <td class="rightAlign">{{ row['Total Amount'] }}</td>
            @for (col of tableColumns; track $index) {
<td class="rightAlign">{{ row[col] }}</td>
}
          </tr>
}
        </tbody>
      </table>
    </div>
}
  </div>
}
</div>
